exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tree-item{display:inline-block;width:100%;margin:1px 0;padding:6px}.new-item{width:auto}.disabled-item{text-decoration:line-through;color:#737577}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/main/webapp/app/components/management/queues/tree-view/queues-tree-view-item.component.css
// module id = 288
// module chunks = 0